<template>
<div class="columns">
  <div class="column">
    <p class="is-size-4">{{ section.standard.name }}</p>
    <p>{{ section.title }}</p>
  </div>
  <div class="column">
    <div class="columns">
      <div class="column">
        <text-input
          :disabled="!assessorType.standard_fed"
          :value="section.setting.secure_setting" 
          @input="updateSecureSetting">
          Secure Setting
        </text-input>
      </div>
      <div class="column is-narrow">
        <text-input 
          disabled 
          :value="castType">
          Data Type
        </text-input>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  props: {
    section: {
      type: Object,
      default: () => ({})
    },
    castType: {
      type: String,
    },
    assessorType: {
      type: Object,
      default: () => ({})
    },
  },

  methods: {
    updateSecureSetting(value) {
      this.$store.commit('assessor/updateStandardSecureSetting', {
        value,
        sectionId: this.section.id
      })
    }
  },
  
  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ])
  }
  
}
</script>